import { useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export default function HoverAnimator({ avatarRef, enabled = true, scale = 1.02, liftY = 0.02, transitionSpeed = 0.1, children }) {
  const [hovered, setHovered] = useState(false);
  const groupRef = useRef();
  useFrame(() => {
    if (!groupRef.current) return;
    const targetS = hovered ? scale : 1;
    const targetY = hovered ? liftY : 0;

    groupRef.current.scale.lerp(
      new THREE.Vector3(targetS, targetS, targetS),
      transitionSpeed
    );
    groupRef.current.position.lerp(
      new THREE.Vector3(0, targetY, 0),
      transitionSpeed
    );
  });

  return (
    <group
      ref={groupRef}
      onPointerOver={(e) => {
        if (enabled) {
          e.stopPropagation();
          setHovered(true);
        }
      }}
      onPointerOut={(e) => {
        if (enabled) {
          e.stopPropagation();
          setHovered(false);
        }
      }}
    >
      {children}
    </group>
  );
}
